import { Badge, Eyebrow, SurfaceRow } from '../../../../components/ui'
import { uiClasses } from '../../../shared/uiClasses'
import { PARTNER_COLORS } from './partnerColors'
import type { TestPartner } from './types'

interface TestsPartnerStripProps {
  partners: TestPartner[]
}

export function TestsPartnerStrip({ partners }: TestsPartnerStripProps) {
  return (
    <div className="mt-4">
      <Eyebrow variant="section" tone="subtle">Partner network</Eyebrow>
      <div className="tests-partner-strip mt-2">
        {partners.map((partner) => (
          <SurfaceRow key={partner.id} className="tests-partner-item">
            <Badge variant={PARTNER_COLORS[partner.name] ?? 'zinc'}>
              {partner.name}
            </Badge>
            <p className={`text-sm/6 ${uiClasses.textSubtle}`}>{partner.tagline}</p>
          </SurfaceRow>
        ))}
      </div>
    </div>
  )
}
